import React, { useEffect, useState } from "react";
import axios from "axios";

const AdminSectionManager = () => {
  const pages = [
    { title: "Home Page", id: "home_page" },
    { title: "About Us", id: "about_us" },
    { title: "Properties", id: "properties" },
    { title: "Contact", id: "contact" },
    { title: "Blog", id: "blog" },
    { title: "Services", id: "services" },
    { title: "Property Owners", id: "property_owners" },
  ];

  const accessToken = localStorage.getItem("authToken");

  const [sections, setSections] = useState({});
  const [selectedFiles, setSelectedFiles] = useState({});
  const [loading, setLoading] = useState({});

  const fetchSections = async () => {
    try {
      const response = await axios.get(
        "https://365luxuryhomes.com/api/sections"
      );

      if (Array.isArray(response.data)) {
        const sectionsData = response.data.reduce((acc, section) => {
          if (section.pageID) {
            acc[section.pageID] = section;
          }
          return acc;
        }, {});

        setSections(sectionsData);
      } else {
        console.error("Invalid response data format:", response.data);
      }
    } catch (error) {
      console.error("Error fetching sections:", error);
    }
  };

  useEffect(() => {
    fetchSections();
  }, []);

  const handleFileChange = (pageId, file) => {
    setSelectedFiles((prev) => ({ ...prev, [pageId]: file }));
  };

  const handleAddOrUpdateSection = async (pageId) => {
    const file = selectedFiles[pageId];
    if (!file) return alert("Please select an image!");

    const maxSizeInBytes = 2 * 1024 * 1024; // 2MB
    if (file.size > maxSizeInBytes) {
      alert("File size exceeds 2MB. Please upload a smaller image.");
      return;
    }

    setLoading((prev) => ({ ...prev, [pageId]: true }));

    const formData = new FormData();
    formData.append("image", file);
    formData.append("pageId", pageId);

    try {
      if (sections[pageId]) {
        // Update existing section
        await axios.put(
          `https://365luxuryhomes.com/api/sections/${sections[pageId].pageID}`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );
        alert("Section updated successfully!");
      } else {
        // Add new section
        await axios.post("https://365luxuryhomes.com/api/sections", formData, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });
        alert("Section added successfully!");
      }
      fetchSections();
    } catch (error) {
      console.error("Error adding/updating section:", error);
    } finally {
      setLoading((prev) => ({ ...prev, [pageId]: false }));
      setSelectedFiles((prev) => ({ ...prev, [pageId]: null }));
    }
  };

  const handleDeleteSection = async (pageId) => {
    if (window.confirm("Are you sure you want to delete this section?")) {
      setLoading((prev) => ({ ...prev, [pageId]: true }));
      try {
        await axios.delete(
          `https://365luxuryhomes.com/api/sections/${sections[pageId]._id}`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );
        alert("Section deleted successfully!");
        fetchSections();
      } catch (error) {
        console.error("Error deleting section:", error);
      } finally {
        setLoading((prev) => ({ ...prev, [pageId]: false }));
      }
    }
  };

  return (
    <div className="container mx-auto p-6">
      <h1 className="text-2xl font-medium text-[#aca9a5] mb-6">
        Manage Sections
      </h1>

      <div className="grid grid-cols-1 gap-6">
        {pages.map((page) => {
          const section = sections[page.id];
          return (
            <div
              key={page.id}
              className="border rounded-md shadow-md p-4 relative"
            >
              <h2 className="text-lg font-semibold text-[#aca9a5] mb-2">
                {page.title}
              </h2>

              <div className="relative">
                {section?.imageUrl || selectedFiles[page.id] ? (
                  <img
                    src={
                      selectedFiles[page.id]
                        ? URL.createObjectURL(selectedFiles[page.id])
                        : section?.imageUrl
                    }
                    alt={page.title}
                    className="w-full h-64 object-cover rounded"
                  />
                ) : (
                  <div className="w-full h-64 flex items-center justify-center bg-gray-100 text-gray-500">
                    No image uploaded (Max size is 2 MB)
                  </div>
                )}
                {loading[page.id] && (
                  <div className="absolute inset-0 bg-white bg-opacity-70 flex items-center justify-center">
                    <span className="loading loading-spinner"></span>
                  </div>
                )}
              </div>

              <div className="mt-4">
                <input
                  type="file"
                  onChange={(e) => handleFileChange(page.id, e.target.files[0])}
                  className="border border-[#aca9a5] rounded w-full p-2 text-[#aca9a5]"
                />
              </div>

              <div className="mt-4 flex justify-between">
                <button
                  onClick={() => handleAddOrUpdateSection(page.id)}
                  className="px-4 py-2 bg-[#aca9a5] text-white rounded hover:bg-[#6c675b]"
                >
                  Save
                </button>
                {section && (
                  <button
                    onClick={() => handleDeleteSection(page.id)}
                    className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
                  >
                    Delete
                  </button>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AdminSectionManager;
